module.exports = __webpack_public_path__ + "static/media/accessories-policy.9e262dcd.svg";